<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('adapters.amazon'), $t('action.authorize')]"
      ></breadcrumb>
      <div class="container">
        <div class="pd20 center">
          <div style="margin-top: 50px; font-size: 24px; color: #d1d1d1">
            {{ $t("rules.buttJoint", [$t("adapters.amazon")]) }}
          </div>
        </div>
        <div class="form-footer">
          <el-button
            type="primary"
            size="medium"
            plain
            :loading="saveSubmitDing"
            @click="saveSubmit"
            >{{ $t("action.agreeAuthorize") }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import AmazonStore from "@/api/adapterAmazonStore";
import Cookies from "@/utils/cookies";

export default {
  mixins: [page],
  components: {},
  data() {
    return {
      saveSubmitDing: false,
    };
  },
  mounted() {},
  created() {
    // console.log(
    //   Cookies.getRowId(),
    //   "===",
    //   window.location.href,
    //   "+++",
    //   Util.parseQueryString(window.location.href, "code")
    // );
  },

  methods: {
    saveSubmit() {
      const self = this;
      self.saveSubmitDing = false;
      const obj = {
        sellingPartnerId: Util.parseQueryString(
          window.location.href,
          "selling_partner_id"
        ),
        code: Util.parseQueryString(window.location.href, "spapi_oauth_code"),
      };
      AmazonStore.accessToken(Cookies.getAmazonRowId(), obj).then(function (
        res
      ) {
        Cookies.removeAmazonRowId();
        if (res.status === 200) {
          self.saveSubmitDing = false;
          self.$message({
            message: self.$t("prompt.authorizeSuccess"),
            type: "success",
          });
          self.$router.push({ name: "adapterAmazons" });
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>